import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { localizedName } from '@/components/localized-name';

/**
 * The package a booking was sold on, wherever bookings are listed.
 *
 * Renders nothing at all for a booking on an unpackaged event, so the lists
 * look exactly as they did before packages existed. Takes the two names rather
 * than a record, because the API spells them differently depending on which
 * shape the row came from — `packageNameEn` on an admin booking row, a nested
 * `package.nameEn` on a time slot's bookings.
 */
export function PackageTag({
  nameEn,
  nameEs,
  className,
}: {
  nameEn?: string | null;
  nameEs?: string | null;
  className?: string;
}) {
  const { i18n } = useTranslation();

  const name = localizedName(
    { nameEn, nameEs },
    i18n.resolvedLanguage ?? 'en',
    false
  );
  if (!name) return null;

  return (
    <Badge variant="outline" className={className}>
      {name}
    </Badge>
  );
}
